import { Select, Spin } from "antd";
import { useQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getBusinesses } from "../../actions/acc_actions";
import { updateBusinessUrn } from "../../context/accountSlice";
import { useTranslation } from "react-i18next"; // ✅

export default function BusinessSelect() {
  const { t } = useTranslation(); // ✅
  const accUrn = useSelector((state) => state.account.urn);
  const dispatch = useDispatch();

  const [selectedBusiness, setSelectedBusiness] = useState(() => {
    const saved = localStorage.getItem("selectedBusiness");
    return saved ? JSON.parse(saved) : null;
  });

  const { isLoading: businessLoading, data: businessesData } = useQuery({
    queryKey: ["userBusinesses", accUrn],
    queryFn: () => getBusinesses(accUrn),
    enabled: !!accUrn,
  });

  useEffect(() => {
    if (!businessesData?.data?.length) return;

    if (selectedBusiness) {
      const exists = businessesData.data.find(
        (b) => b.urn === selectedBusiness.businessUrn
      );
      if (exists) {
        dispatch(updateBusinessUrn(selectedBusiness));
        return;
      }
    }

    const firstBiz = businessesData.data[0];
    const defaultSelection = {
      businessUrn: firstBiz.urn,
      businessSlug: firstBiz.slug,
    };
    setSelectedBusiness(defaultSelection);
    localStorage.setItem("selectedBusiness", JSON.stringify(defaultSelection));
    dispatch(updateBusinessUrn(defaultSelection));
  }, [businessesData, selectedBusiness, dispatch]);

  const handleChange = (urn) => {
    const selectedBiz = businessesData?.data?.find((b) => b.urn === urn);
    if (!selectedBiz) return;

    const selection = {
      businessUrn: selectedBiz.urn,
      businessSlug: selectedBiz.slug,
    };

    setSelectedBusiness(selection);
    localStorage.setItem("selectedBusiness", JSON.stringify(selection));
    window.location.reload();
    dispatch(updateBusinessUrn(selection));
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      <h5 style={{ margin: 0 }}>{t("business_label")}:</h5> {/* ✅ */}
      <Select
        className="business-dropdown"
        loading={businessLoading}
        value={selectedBusiness?.businessUrn || null}
        placeholder={t("select_a_business")} // ✅
        onChange={handleChange}
        style={{ width: 280 }}
        notFoundContent={
          businessLoading ? <Spin size="small" /> : t("no_businesses") // ✅
        }
        optionLabelProp="label"
      >
        {businessesData?.data?.map((biz) => (
          <Select.Option key={biz.urn} value={biz.urn} label={biz.name}>
            <div className="business-option">
              <div className="business-name">{biz.name}</div>
            </div>
          </Select.Option>
        ))}
      </Select>
    </div>
  );
}
